/* tslint:disable */
/* eslint-disable */
export enum WorkDebtorOverviewCategoryEnum {
  Standard = 'standard',
  MissingParts = 'missing-parts',
  Kleiv = 'kleiv'
}
